package com.jingfangpai.api.clients

import com.jingfangpai.common.data.response.ApiResponse
import kotlinx.serialization.Serializable
import kotlinx.serialization.decodeFromString
import com.jingfangpai.common.coroutines.applicationDispatcher
import kotlinx.coroutines.launch
import io.ktor.http.*
import io.ktor.client.plugins.*
import io.ktor.client.request.*
import com.jingfangpai.common.json.json
import kotlin.js.JsName
import io.ktor.content.TextContent
import io.ktor.client.call.body
import com.jingfangpai.api.base.BaseServiceClient
import com.jingfangpai.common.orm.mapping.SyndromeIndication

object SyndromeIndicationApiClient :BaseServiceClient() {

	@JsName("save")
	fun save(syndromeIndication:com.jingfangpai.common.orm.mapping.SyndromeIndication, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.SyndromeIndication>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.SyndromeIndication> = httpClient.post {
				    url("/api/settings/syndromeIndication/save?$params")
				    setBody(TextContent(json.encodeToString(com.jingfangpai.common.orm.mapping.SyndromeIndication.serializer(),syndromeIndication), io.ktor.http.ContentType.Application.Json))
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}

}
